import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'vant/lib/index.css';
import '@/assets/tailwind.css'
import './main.scss'
createApp(App).use(store).use(router).mount('#app')
